import React, { useState } from 'react';

// Hooks
import useRecoverCustomer from '@src/hooks/useCustomerRecover';

// Comps
import { TextField } from '@arctheme-components/elements/TextField/TextField';
import { Link } from '@arctheme-components/elements/Link/Link';
import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';
import ButtonSpinner from '@src/stories/elements/ButtonSpinner/ButtonSpinner';
import { Button } from '@src/stories/elements/Button/Button';

type Props = {
    onCancel: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    section: any;
    blockSettings?: any;
};

const AccountForgotPassword = ({ onCancel, section, blockSettings }: Props) => {
    const forgotPasswordSettings = blockSettings?.forgotPassword || {};
    
    const {
        title_forgot_password = forgotPasswordSettings?.title_forgot_password || "Forgot password?",
        tagline_forgot_password = forgotPasswordSettings?.tagline_forgot_password || "No worries! We can help you with resetting your password!",
        email_label = forgotPasswordSettings?.email_label || "Email address",
        email_placeholder = forgotPasswordSettings?.email_placeholder || "Email address",
        button_label_forgot_password_submit = forgotPasswordSettings?.button_label_forgot_password_submit || "Submit",
        button_style_forgot_password_submit = forgotPasswordSettings?.button_style_forgot_password_submit || "primary",
        button_label_cancel = forgotPasswordSettings?.button_label_cancel || "Cancel Request"
    } = section;

    const [email, setEmail] = useState('');

    const { recoverCustomer, loading, error, success } = useRecoverCustomer();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await recoverCustomer(email);
    };

    return (
        <form
            id='forgotForm'
            onSubmit={handleSubmit}
            className='account-page__form'
        >
            <div className='flex flex-col gap-y-4'>
                <h4>{title_forgot_password}</h4>

                <p className='b2'>{tagline_forgot_password}</p>

                {error && (
                    <Paragraph
                        text={error}
                        type='errors'
                    />
                )}

                {success && (
                    <Paragraph
                        text={success}
                        type='success font-bold'
                    />
                )}

                <TextField
                    className='w-full'
                    inputType='email'
                    id='emailForgot'
                    name='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required={true}
                    label={email_label}
                    placeholder={email_placeholder}
                />

                <div className='flex w-full flex-row  gap-4'>
                    <ButtonSpinner
                        isLoading={loading}
                        classes={`button button-${button_style_forgot_password_submit} w-full`}
                        ariaLabel='Submit recover password form'
                        loadingText={'Submitting...'}
                        disabled={success}
                    >
                        {button_label_forgot_password_submit}
                    </ButtonSpinner>

                    <Button
                        onClick={onCancel}
                        className='button button-secondary w-full'
            
                        label={button_label_cancel}
                    />
                
                </div>
            </div>
        </form>
    );
};

export default AccountForgotPassword;